Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagePathnames = void 0;
var PagePathnames = exports.PagePathnames = {
  AboutYou: '/onboarding/about_you',
  Car: '/onboarding/car',
  Flights: '/onboarding/flights',
  Diet: '/onboarding/diet',
  House: '/onboarding/building',
  Goals: '/onboarding/goals',
  Summary: '/onboarding/summary',
  Steps: '/onboarding/steps',
  StepsSuccess: '/onboarding/steps_success'
};